(function () {
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function parseJsonData(el, dataAttr) {
    var n = q(el, '[data-' + dataAttr + ']');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  function haversine(a, b) {
    var R = 6371;
    var d = function (x) { return x * Math.PI / 180; };
    var dLat = d(b.lat - a.lat), dLng = d(b.lng - a.lng);
    var s = Math.sin(dLat / 2) ** 2 + Math.cos(d(a.lat)) * Math.cos(d(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }
  function loadMaps(apiKey, cb) {
    if (window.google && window.google.maps) { cb(); return; }
    window._gmapsQ = window._gmapsQ || [];
    window._gmapsQ.push(cb);
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      if (!window._gmapsPolling) {
        window._gmapsPolling = true;
        var poll = setInterval(function () {
          if (window.google && window.google.maps) {
            clearInterval(poll);
            window._gmapsPolling = false;
            (window._gmapsQ || []).forEach(function (f) { try { f(); } catch (e) {} });
            window._gmapsQ = [];
          }
        }, 50);
      }
      return;
    }

    if (window._gmapsLoading) return;
    window._gmapsLoading = true;
    var s = document.createElement('script');
    s.defer = true;
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(apiKey) + '&callback=__gmapsReady';
    document.head.appendChild(s);
    window.__gmapsReady = function () {
      (window._gmapsQ || []).forEach(function (f) { try { f(); } catch (e) {} });
      window._gmapsQ = [];
      window._gmapsLoading = false;
    };
  }
  function makeEl(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstElementChild;
  }

  function ITSL(section) {
    this.root = section;
    this.cfg = parseJsonData(section, 'itsl-config') || {};
    this.locs = parseJsonData(section, 'itsl-locations') || [];
    this.api = section.getAttribute('data-api-key') || '';
    this.listMax = parseInt(section.getAttribute('data-list-max-height') || '360', 10);
    this.map = null;
    this.iw = null;
    this.userMk = null;
    this.markers = [];
  }

  ITSL.prototype.init = function () {
    var self = this;
    loadMaps(this.api, function () { self.onReady(); });
  };

  ITSL.prototype.onReady = function () {
    var mEl = document.getElementById(this.cfg.mapElId);
    if (!mEl) return;
    var listEl = document.getElementById(this.cfg.listElId);
    var bounds = new google.maps.LatLngBounds();
    this.map = new google.maps.Map(mEl, { mapTypeControl: false, streetViewControl: false });
    this.iw = new google.maps.InfoWindow();

    var locs = this.locs.map(function (s, i) { s._i = i; return s; });
    this.markers = locs.map(function (s, i) {
      var p = { lat: Number(s.lat), lng: Number(s.lng) };
      var mk = new google.maps.Marker({ position: p, map: this.map, label: String(i + 1), title: s.title || '' });
      mk.addListener('click', this.onMarkerClick.bind(this, mk, s));
      bounds.extend(p);
      return mk;
    }, this);

    if (locs.length) this.map.fitBounds(bounds);
    else { this.map.setCenter({ lat: 33.8, lng: -117.9 }); this.map.setZoom(9); }

    this.buildList(locs, null);
    if (listEl) listEl.addEventListener('click', this.onListClick.bind(this));

    var geoBtn = q(this.root, '[data-geo]');
    if (geoBtn && navigator.geolocation) {
      geoBtn.addEventListener('click', function () {
        navigator.geolocation.getCurrentPosition(function (pos) {
          var user = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          var sorted = locs.slice().sort(function (a, b) { return haversine(user, a) - haversine(user, b); });
          this.buildList(sorted, user);
          this.centerUser(user);
        }.bind(this));
      }.bind(this));
    }
  };

  ITSL.prototype.onMarkerClick = function (marker, store) {
    var link = 'https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng;
    var html = '<div class="itsl__iw"><strong>' + (store.title || '') + '</strong>' +
      '<div>' + (store.address || '') + '</div>' +
      (store.hours ? '<div>' + store.hours + '</div>' : '') +
      '<div style="margin-top:.5rem;"><a href="' + link + '" target="_blank" rel="noopener">Directions</a></div></div>';
    this.iw.setContent(html);
    this.iw.open(this.map, marker);
  };

  ITSL.prototype.onListClick = function (e) {
    var li = e.target.closest('.itsl__item');
    if (!li) return;
    var idx = Number(li.getAttribute('data-idx'));
    if (isNaN(idx)) return;
    google.maps.event.trigger(this.markers[idx], 'click');
    this.map.panTo(this.markers[idx].getPosition());
    this.map.setZoom(Math.max(this.map.getZoom(), 14));
  };

  ITSL.prototype.centerUser = function (user) {
    if (this.userMk) this.userMk.setMap(null);
    this.userMk = new google.maps.Marker({
      map: this.map,
      position: user,
      icon: { path: google.maps.SymbolPath.CIRCLE, scale: 6, strokeWeight: 2, strokeColor: '#4285F4', fillColor: '#4285F4', fillOpacity: .7 },
      title: 'You'
    });
    this.map.setCenter(user);
    this.map.setZoom(11);
  };

  ITSL.prototype.buildList = function (arr, user) {
    var ul = document.getElementById(this.cfg.listElId);
    if (!ul) return;
    ul.style.maxHeight = this.listMax + 'px';
    ul.innerHTML = '';
    arr.forEach(function (s, i) {
      var dist = user ? haversine(user, s) : null;
      var link = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
      var node = makeEl(
        '<li class="itsl__item" data-idx="' + s._i + '">' +
          '<div class="itsl__num">' + (i + 1) + '</div>' +
          '<div class="itsl__meta">' +
            '<div class="itsl__title">' + (s.title || '') + '</div>' +
            '<div class="itsl__addr">' + (s.address || '') + '</div>' +
            (s.hours ? '<div class="itsl__hours">' + s.hours + '</div>' : '') +
            (dist ? '<div class="itsl__dist">' + dist.toFixed(1) + ' km</div>' : '') +
            '<a class="itsl__dir" href="' + link + '" target="_blank" rel="noopener">Directions</a>' +
          '</div>' +
        '</li>'
      );
      ul.appendChild(node);
    });
  };

  function boot() {
    qa(document, '[data-itsl]').forEach(function (el) {
      if (el.__itsl) return;
      var inst = new ITSL(el);
      el.__itsl = inst;
      inst.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ITSL = ITSL;
})();
